<ng-container *transloco="let t">
  <div class="p-grid faq p-nogutter p-jc-center section-margin">
    <div class="p-text-center faq__header">
      <h2 class="home-heading">
        {{ t('faq.header.part1') }}<span>{{ t('faq.header.part2') }}</span>
      </h2>
    </div>

    <div class="p-col-12 p-d-flex p-jc-center backgroundWrapper">
      <div class="p-grid wrapper p-jc-center">
        <div
          class="p-col-12 p-md-6 p-xl-4"
          *ngFor="let tile of faqTiles">
          <div class="p-shadow-9 faq__tale">
            <p
              class="textYellow p-text-bold p-text-center p-mb-2 faq__tale__header">
              {{ tile.header }}
            </p>
            <h3
              class="textBlue p-text-bold p-text-center p-mb-2 faq__tile__question">
              {{ tile.question }}
            </h3>
            <p
              class="textBlue faq__tale__answer"
              [innerHTML]="tile.answer"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
